/**
 * Formata ISO date string para formato brasileiro (DD/MM/YYYY HH:MM)
 */
export const formatDate = (iso: string | null): string => {
  if (!iso) return '-';
  const d = new Date(iso);
  return `${d.toLocaleDateString('pt-BR')} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
};

/**
 * Data local no formato YYYY-MM-DD (toISOString converte pra UTC e desloca
 * o dia depois das 21h em UTC-3)
 */
export const toLocalYmd = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

/**
 * Retorna cor Chakra baseada na taxa de sucesso
 */
export const getTaxaColor = (taxa: number): string => {
  if (taxa >= 95) return 'green.500';
  if (taxa >= 80) return 'orange.500';
  return 'red.500';
};

/**
 * Retorna colorScheme Chakra baseado na flag de log
 */
export const getFlagColor = (flag: string): string => {
  if (flag === 'ERROR') return 'red';
  if (flag === 'WARNING') return 'orange';
  return 'gray'; // INFO/demais: neutro — log informativo nao e "sucesso" (verde); alinha com getFlagBg
};

/**
 * Formata duracao em segundos para string legivel
 */
export const formatDuracao = (seg: number): string => {
  if (seg >= 3600) return `${Math.floor(seg / 3600)}h ${Math.floor((seg % 3600) / 60)}m`;
  if (seg >= 60) return `${Math.floor(seg / 60)}m ${seg % 60}s`;
  return `${seg}s`;
};

/**
 * Status de um bot baseado na ultima execucao e taxa de sucesso
 */
export type BotStatus = 'ok' | 'warning' | 'error' | 'inactive';

export const STATUS_CONFIG: Record<BotStatus, { label: string; color: string }> = {
  ok: { label: 'Funcionando', color: 'green' },
  warning: { label: 'Atencao', color: 'orange' },
  error: { label: 'Com problema', color: 'red' },
  inactive: { label: 'Inativo', color: 'gray' },
};

/**
 * Cor Chakra para status ok/warning/error/inactive (fonte unica entre as views)
 */
export const getStatusColor = (status: string): string =>
  STATUS_CONFIG[status as BotStatus]?.color || 'green';
